/**
 * Types of objects, usually each type uses a different material
 */
export var PreProcessingTypes;
(function (PreProcessingTypes) {
    PreProcessingTypes["SWISSTOPO_ROOF"] = "swisstopoRoof";
    PreProcessingTypes["SWISSTOPO_WALL"] = "swisstopoWall";
    PreProcessingTypes["SWISSTOPO_FLOOR"] = "swisstopoFloor";
    PreProcessingTypes["PROJECT_SKETCH_ROOF"] = "projectSketchRoof";
    PreProcessingTypes["PROJECT_SKETCH_WALL"] = "projectSketchWall";
    PreProcessingTypes["PROJECT_SKETCH_FLOOR"] = "projectSketchFloor";
    PreProcessingTypes["CUSTOM_BUILDINGS_ROOF"] = "customBuildingsRoof";
    PreProcessingTypes["CUSTOM_BUILDINGS_WALL"] = "customBuildingsWall";
    PreProcessingTypes["CUSTOM_BUILDINGS_FLOOR"] = "customBuildingsFloor";
    PreProcessingTypes["GROUND"] = "ground";
    PreProcessingTypes["GROUND_LAKE"] = "groundLake";
    PreProcessingTypes["GROUND_GREEN"] = "groundGreen";
    PreProcessingTypes["GROUND_RIVER"] = "groundRiver";
    PreProcessingTypes["GROUND_CUSTOM_TARGET"] = "groundCustomTarget";
    PreProcessingTypes["TREES"] = "trees";
})(PreProcessingTypes || (PreProcessingTypes = {}));
export const ALL_PRE_PROCESSING_TYPES = Object.values(PreProcessingTypes);
export const TERRAIN_LINE_KIND = {
    ROAD: 1,
    ANALYSIS_BORDER: 2,
    LEGAL_BORDER: 3,
    BUILDABLE_BORDER: 4,
};
